import {Component, OnInit, TemplateRef, OnDestroy} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';

import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BatchstampService} from '../../batchstamp/batchstamp.service';
import {BsModalService} from 'ngx-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {Subscription} from 'rxjs';

@Component({
  selector: 'lock-list-stamp',
  templateUrl: './modalLockListStamp.template.html',
  styles: [`
    .lock-modal-title { font-family: Inter, sans-serif; font-weight: 600; font-size: 18px; color: #374957; margin: 0; }
    .lock-alert { display: flex; align-items: flex-start; gap: 8px; padding: 12px 16px; background: #FEF2F2; border-left: 4px solid #EC5858; margin-bottom: 16px; border-radius: 4px; }
    .lock-alert-text { font-family: Inter, sans-serif; font-weight: 400; font-size: 14px; color: #E7000B; margin: 0; line-height: 1.4; }
    .lock-label { font-family: Inter, sans-serif; font-weight: 600; font-size: 14px; color: #374957; margin-bottom: 8px; display: block; }
    .lock-input { background: #F9FAFB; border: 1px solid #E5E7EB; border-radius: 4px; padding: 8px 12px; width: 100%; color: #5F7D95; font-size: 14px; outline: none; }
    .lock-input:disabled { background: #F9FAFB; cursor: not-allowed; }
    .lock-input:focus { border-color: #007bff; }
    .lock-helper-text { font-family: Inter, sans-serif; font-weight: 400; font-size: 12px; color: #6A7282; margin-bottom: 8px; display: block; }
    .lock-table-input { background: #F9FAFB; border: 1px solid #E5E7EB; color: #5F7D95; font-size: 14px; padding: 8px 12px; outline: none; }
    .lock-table-input:disabled { background: #F9FAFB; color: #5F7D95; }
    .lock-table-input:focus { border-color: #007bff; z-index: 1; }
    .lock-checkbox-row { display: flex; align-items: center; gap: 10px; margin-top: 16px; margin-bottom: 16px; }
    .lock-checkbox-label { font-family: Inter, sans-serif; font-weight: 400; font-size: 14px; color: #374957; margin: 0; cursor: pointer; }
    .lock-contact-row { display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; background: #F9FAFB; border: 1.25px solid #E5E7EB; border-radius: 10px; margin-bottom: 8px; }
    .lock-contact-info { display: flex; align-items: center; gap: 12px; }
    .lock-contact-title { font-family: Inter, sans-serif; font-weight: 600; font-size: 14px; color: #374957; margin: 0; line-height: 1.4; }
    .lock-contact-desc { font-family: Inter, sans-serif; font-weight: 400; font-size: 12px; color: #5F7D95; margin: 0; line-height: 1.4; }
    .lock-btn-cancel { background: #E5E7EB; color: #5F7D95; border-radius: 4px; border: none; padding: 8px 16px; font-weight: 400; font-size: 14px; cursor: pointer; font-family: Inter, sans-serif; }
    .lock-btn-submit { background: #EC5858; color: #FFFFFF; border-radius: 4px; border: none; padding: 8px 16px; font-weight: 400; font-size: 14px; margin-right: 8px; cursor: pointer; font-family: Inter, sans-serif; }
    .switch { position: relative; display: inline-block; width: 34px; height: 20px; margin: 0; }
    .switch input { opacity: 0; width: 0; height: 0; }
    .slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #E5E7EB; transition: .4s; border-radius: 34px; }
    .slider:before { position: absolute; content: ""; height: 16px; width: 16px; left: 2px; bottom: 2px; background-color: white; transition: .4s; border-radius: 50%; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
    input:checked + .slider { background-color: #007bff; }
    input:checked + .slider:before { transform: translateX(14px); }
  `],
})
export class ModalLockListStampComponent implements OnInit, OnDestroy {
  reasonOptions = [
    { label: 'Sản phẩm hết hạn', value: 'EXPIRED' },
    { label: 'Lô hàng bị lỗi', value: 'DEFECTIVE' },
    { label: 'Sản phẩm bị thu hồi', value: 'RECALLED' },
    { label: 'Hàng giả/Hàng nhái', value: 'COUNTERFEIT' },
    { label: 'Lý do khác', value: 'OTHER' }
  ];

  batch_detail: any;
  closeBtnName: string;

  public message: any = {type: '', content: ''};
  public FormCancelStamp: FormGroup;
  is_loading = false;
  id_start: any;
  id_end: any;

  data_cancel: any = {};

  is_modal_confirm: boolean = false;
  modalRef2: BsModalRef;

  subcribe: Subscription = null;
  formCratingBatch: FormGroup = this.fb.group({
    is_cratingStamps: ['cratingStampsSingle'],
    // is_cratingStampsList: [false],
    // is_cratingProductSingle: [false],
    // is_cratingProductList: [false],
    // is_apply: [false],
    is_routing: [false],
    stampCodeList: this.fb.array([]),
    name: [''],
    reason: [null, [Validators.required]],
    reasonType: [null, [Validators.required]],
    userMessage: [''],
    showContactBusiness: [false],
    showContactIcheck: [false],
    isFake: [false],
  });

  constructor(
    private fb: FormBuilder,
    public bsModalRef: BsModalRef,
    private batchService: BatchstampService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {
    this.subcribe = this.modalService.onHide.subscribe((reason: string) => {
      this.is_modal_confirm = false;
    });
  }

  listContent = [];
  errorMessage = [];
  groupItems = [];

  ngOnInit() {
    // console.log(this.batch_detail);
    this.id_start = this.formatSerialMinSixCharacter(
      this.batch_detail.id_start
    );
    this.id_end = this.formatSerialMinSixCharacter(this.batch_detail.id_end);
    // this.createForm();


    this.formCratingBatch.controls['is_routing'].valueChanges.subscribe(
      (val) => {
        // $("html, body").animate({ scrollTop: 0 }, "slow");
        this.listContent = [];
        this.errorMessage = [];
        this.groupItems = [];
        this.formCratingBatch.controls['stampCodeList'].reset();
        this.codeList();
      }
    );
  }

  ngOnDestroy() {
    if (this.subcribe) {
      this.subcribe.unsubscribe();
    }
  }

  modalConfirmCancel(data: any, template: TemplateRef<any>) {
    if (!this.formCratingBatch.value.stampCodeList || (this.formCratingBatch.value.stampCodeList && this.formCratingBatch.value.stampCodeList.length <= 0)) {
      this.toastr.warning('Bạn chưa nhập tem', 'Cảnh báo', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    if (!this.formCratingBatch.value.reasonType) {
      this.toastr.warning('Bạn chưa chọn lý do khóa', 'Cảnh báo', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    if (!this.formCratingBatch.value.reason || (this.formCratingBatch.value.reason && this.formCratingBatch.value.reason.trim().length <= 0)) {
      this.toastr.warning('Bạn chưa nhập nội dung cho người dùng biết', 'Cảnh báo', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    this.data_cancel = data;
    this.is_modal_confirm = true;
    this.modalRef2 = this.modalService.show(template, {class: 'second'});
  }

  // createForm() {
  //   this.FormCancelStamp = this.fb.group({
  //     id_start: [
  //       { value: this.id_start, disabled: this.batch_detail.readonly },
  //       [Validators.required],
  //     ],
  //     id_end: [
  //       { value: this.id_end, disabled: this.batch_detail.readonly },
  //       [Validators.required],
  //     ],
  //     reason: [null, [Validators.required]],
  //   });
  // }

  parse_int(s) {
    return parseInt(s);
  }

  submitCancelStamp(data) {
    this.is_loading = true;
    // console.log(data);

    let formValue = this.formCratingBatch.value;
    let stampCodeList = formValue.stampCodeList.map((gg) => {
      return {
        note: formValue.reason,
        reasonType: formValue.reasonType,
        showContactBusiness: formValue.showContactBusiness,
        showContactIcheck: formValue.showContactIcheck,
        isFake: formValue.isFake,
        status: 1,
        batchId: Number(this.batch_detail.id),
        idStart: Number(gg.serialFirst.trim()),
        idEnd: Number(gg.serialLast.trim()),
      };
    });
    console.log('stampCodeList', stampCodeList);
    this.batchService
      .restoreListStamp({items: stampCodeList})
      .toPromise()
      .then((res: any) => {
        console.log('res', res)
        this.is_loading = false;
        if (res.code == 1) {
          this.modalRef2.hide();
          this.modalRef2 = null;
          this.bsModalRef.hide();
          this.bsModalRef = null;
          if (res.data.success > 0) {
            this.toastr.success(`Khóa thành công ${res.data.success} tem, thất bại ${res.data.fail} tem !`, '', {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
          } else {
            this.toastr.warning(`Khóa thành công ${res.data.success} tem, thất bại ${res.data.fail} tem !`, '', {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
          }
        } else {
          console.log('error:false', res.message);
          let mess = res.message
            ? res.message
            : 'Thao tác khóa không thành công. Vui lòng thử lại sau!';
          this.toastr.warning(mess, 'Thông báo', {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
        }
      })
      .catch((err: any) => {
        this.is_loading = false;
        console.log('catch:', err);
        let mess = err.message
          ? err.message
          : 'Thao tác khóa không thành công. Vui lòng thử lại sau!';
        this.toastr.error(mess, 'Thông báo', {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        });
      });
  }

  formatSerialMinSixCharacter(serial) {
    let serial6char: string = '';
    serial = serial.toString();
    if (serial) {
      let pad = '000000';
      serial6char = pad.substring(0, 6 - serial.length) + serial;
    }
    return serial6char;
  }


  codeList(): FormArray {
    return this.formCratingBatch.get('stampCodeList') as FormArray;
  }

  newCodeList(): FormGroup {
    return this.fb.group({
      prefix: this.batch_detail.prefix,
      serialFirst: '',
      serialLast: '',
      data: [],
      mess: '',
    });
  }

  addCodeList() {
    this.codeList().push(this.newCodeList());
  }

  removeCodeList(i) {
    this.codeList().removeAt(i);
  }

  removeCodeListAll() {
    while (this.codeList().length !== 0) {
      this.codeList().removeAt(0);
    }
  }

  stampCodeChanged(i) {
    console.log(222, this.formCratingBatch);
    // console.log('this.formCratingBatch.value.stampCodeList[i]', this.formCratingBatch.value.stampCodeList[i])
    if (
      this.formCratingBatch.value.stampCodeList[i].prefix.trim() !== '' &&
      this.formCratingBatch.value.stampCodeList[i].serialFirst.trim() !== '' &&
      this.formCratingBatch.value.stampCodeList[i].serialLast.trim() !== ''
    ) {
      // tslint:disable-next-line:radix max-line-length
      if (
        parseInt(
          this.formCratingBatch.value.stampCodeList[i].serialFirst.trim()
        ) >
        parseInt(this.formCratingBatch.value.stampCodeList[i].serialLast.trim())
      ) {
        // console.log(1111);
        this.formCratingBatch.value.stampCodeList[i].mess =
          'Serial cuối phải lớn hơn Serial đầu';
      } else {
        this.formCratingBatch.value.stampCodeList[i].mess = '';
      }
    }
  }


}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/popup/modalLockListStamp/modalLockListStamp.component.ts